/**
 * MODULE: _shared/frontend/lib/frontend/utils/emailTemplateEditBridge.ts
 * PURPOSE: Open golden-path EmailTemplateEditModal app-wide (assistant form_catalog, template library).
 */

import type { EmailTemplateCreateSuccessHint } from './emailTemplateCreateBridge';

export type EmailTemplateEditOpenOptions = {
  templateId: string;
  successHint?: EmailTemplateCreateSuccessHint;
  coachInAssistant?: boolean;
};

export const OPEN_EMAIL_TEMPLATE_EDIT_EVENT = 'brazn:open-email-template-edit';

/** Request the app-level EmailTemplateEditModal (mounted in AppLayout). */
export function requestOpenEmailTemplateEdit(options: EmailTemplateEditOpenOptions): void {
  if (typeof window === 'undefined') return;
  const templateId = (options.templateId || '').trim();
  if (!templateId) return;
  window.dispatchEvent(
    new CustomEvent<EmailTemplateEditOpenOptions>(OPEN_EMAIL_TEMPLATE_EDIT_EVENT, {
      detail: { ...options, templateId },
    })
  );
}

export function subscribeOpenEmailTemplateEdit(
  listener: (options: EmailTemplateEditOpenOptions) => void
): () => void {
  if (typeof window === 'undefined') return () => undefined;
  const handler = (event: Event) => {
    const detail = (event as CustomEvent<EmailTemplateEditOpenOptions>).detail;
    if (!detail?.templateId?.trim()) return;
    listener(detail);
  };
  window.addEventListener(OPEN_EMAIL_TEMPLATE_EDIT_EVENT, handler);
  return () => window.removeEventListener(OPEN_EMAIL_TEMPLATE_EDIT_EVENT, handler);
}
